var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "importOrder" } },
    [
      _c(
        "div",
        { staticClass: "yto-table" },
        [
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.importOrder } },
                [_vm._v("全部导入")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "max-height": "720",
                "row-class-name": _vm.tableRowClassName,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  type: "index",
                  width: "60",
                  align: "center",
                  label: "序号",
                  resizable: false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.limit * (_vm.pageNo - 1) + scope.$index + 1
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "错误信息" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "light",
                              content: scope.row.errorContent,
                              placement: "top",
                            },
                          },
                          [
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(scope.row.errorContent)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveName",
                  label: "收件人姓名",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveAddress",
                  label: "收件人地址",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveMobile",
                  label: "收件人手机",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receivePhone",
                  label: "收件人固话",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "sendName", label: "发件人姓名", align: "left" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sendAddress",
                  label: "发件人地址",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sendMobile",
                  label: "发件人手机",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sendPhone",
                  label: "发件人固话",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名称",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "productNumbers", label: "数量", align: "left" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productCode",
                  label: "产品类型",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.productCode == "YZD" ? "圆准达" : "普快"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "incrementName",
                  label: "增值服务",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "light",
                              content: scope.row.remark,
                              placement: "top",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(scope.row.remark))])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticNo",
                  label: "客户订单号",
                  align: "left",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.editOrder(scope)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteOrder(scope)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageNo,
              "page-sizes": [100, 300, 500],
              "page-size": _vm.limit,
              layout: "total, sizes, prev, pager, next",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.limitChange,
              "current-change": _vm.pageChange,
              "update:currentPage": function ($event) {
                _vm.pageNo = $event
              },
              "update:current-page": function ($event) {
                _vm.pageNo = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑订单",
            visible: _vm.editDialogVisible,
            width: "980px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialogVisible = $event
            },
            close: function ($event) {
              _vm.editDialogVisible = false
            },
          },
        },
        [
          _vm.editDialogVisible
            ? _c("order-info", {
                attrs: { data: _vm.rowData, disabled: false },
                on: { closeDialog: _vm.closeDialog, save: _vm.save },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }